import React from 'react';
import PropTypes from 'prop-types';
import {buildChildrenWithProps} from '../helpers/';
import {STEPS_PROPTYPE, STEP_CLASSNAME} from '../helpers/consts';

const Step = ({
    currentStep,
    navigateNext,
    navigateBack,
    navigateTo,
    steps,
    numOfSteps,
    id,
    children,
    className,
    title,
    isLoading
}) => {

    if (currentStep.id !== id) {
        return null;
    }

    const _children = buildChildrenWithProps(children, {
        currentStep,
        navigateNext,
        navigateBack,
        navigateTo,
        steps,
        numOfSteps,
        isLoading
    });

    const wrapperProps = {
        id,
        title,
        className: [STEP_CLASSNAME, className].join(' ').trim()
    };

    return (
        <div {...wrapperProps}>{_children}</div>
    );
};

Step.propTypes = {
    currentStep: STEPS_PROPTYPE,
    backHandler: PropTypes.func,
    nextHandler: PropTypes.func,
    jumpToStep: PropTypes.func,
    steps: PropTypes.arrayOf(STEPS_PROPTYPE),
    numOfSteps: PropTypes.number,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    className: PropTypes.string,
    title: PropTypes.string
};

export default Step;
